import { inject } from 'vue-demi';

export const WORDING_KEY = 'predict-use-analyze-wording';

/**
 * 根据 useAnalyzeWording 配置选择对应的 locale key。
 * 使用"分析"时返回 baseKey，使用"预测"时返回 baseKey + 'Predict'。
 */
export function useWording() {
  const useAnalyze = inject<boolean>(WORDING_KEY, false);

  function pick(
    $t: (key: string) => string,
    analyzeKey: string,
    predictKey: string,
  ): string {
    return useAnalyze ? $t(analyzeKey) : $t(predictKey);
  }

  return { useAnalyze, pick };
}
